---
nb:
  om_dashboard:
    active_alarm: Aktiv alarm
    alarm:
      alarm: Alarm
      alarm_category: Alarmkategori
      alarms_as_of: "{num} Aktive {critical} alarmer per {when}"
      all_active_alarms: Aktive alarmer
      command: Kommando
      critical: kritiske
      critical_active_alarms: Aktive kritiske alarmer
      critical_high_alarm: Kritisk høy alarm
      critical_low_alarm: Kritisk lav alarm
      duration: Varighet
      end: Slutt
      energy_losses: Energittap [MWh]
      high_alarm: Varsel - høy alarm
      hydro_component_name: Turbin
      inverter_name: Likeretter
      last_update: Siste oppdatering
      low_alarm: Varsel - lav alarm
      mppt_name: MPPT
      ok: OK
      operational_status: Driftsstatus
      recent_alarms_and_events: Nylige alarmer og hendelser
      sensor_name: Sensornavn
      sensor_type: Sensortype
      setpoint: Settpunkt
      solar_component_name: Likeretter
      start: Start
      status: Status
      warning: Varsel
      wind_component_name: Turbin
    alarm_status:
      environmental: Miljøforhold
      force_majeure: Force majeure
      grid_failure: Nettfeil
      inverter_outage: Likeretter utfall
      manufacturer: Leverandøralarm
      mppt_outage: MPPT utfall
      no_data: Ingen data
      normal_operation: Normal drift
      owner: Stopper av eier
      power_limitation: Lastbegrenser
      snow_coverage: Snødekke
      still_active: Fortsatt aktiv
      stopped_by_owner: Stopper av eier
      string_anomaly: Strenganomali
      turbine_ok: Turbin OK
    alarms: Alarmer
    alarms_lowcase: alarmer
    component_status: Komponentstatus
    drilldown:
      accumulated_hours: Akkumulerte timer med alarmer
      accumulated_hours_of_operational_statuses: Akkumulerte timer per operasjonelle status
      active_power: Aktiv effekt
      alarm_codes: Alarmkoder codes
      alarm_filter: Filtrer på sensor/nøkkelord
      alarm_frequency_disclaimer: Timer med innstråling over minimumsgrensen for innstråling (standardverdi er 60 W/m²)
      all_mppts: Alle MPPTer
      annual_limit: Årlig grense
      any: Alle
      availability_target: Mål
      charts: Diagrammer
      choose_field: Velg felt
      choose_mppt: Velg MPPT...
      compare_another: Sammenlign
      compare_with: Sammenlign med
      compare_with_another: Legg til en annen sammenligning
      compare_with_inverter: Sammenlign {inverter_name} med
      compare_with_turbine: Sammenlign {turbine_name} med
      compared_power_curves: 'Effektkurve sammenligning:'
      contractual_availability: Kontraktsmessig tilgjengelighet
      critical_alarms: Kritiske alarmstatuser
      current: Strøm
      current_env_flow: Gjeldende minstevannføringskrav
      date_summer: Dato sommer
      date_winter: Dato vinter
      dc_current_unit: DC Strøm [A]
      dc_current_unit_normalized: DC Strøm [A]
      dc_power_unit: DC Kraft [kW]
      dc_power_unit_normalized: DC Kraft [%]
      dc_voltage_unit: DC Spenning [V]
      dc_voltage_unit_normalized: DC Spenning [%]
      downtime_hours: Driftsstopp timer
      end_date: Sluttdato
      end_time: Sluttid
      energy_based: Energibasert beregning for tilgjengelighet.
      energy_based_availability: Energibasert tilgjengelighet
      energy_losses: Energittap
      energy_performance_index: Energiprestasjonsindeks
      energy_produced: Energi produsert
      expected_operating_hours: Forventet driftstid
      export_menu:
        download_csv: Last ned CSV-fil
        download_jpg: Last ned JPEG-bilde
        download_pdf: Last ned PDF-dokument
        download_png: Last ned PNG-bilde
        download_svg: Last ned SVG-vektor bilde
        download_xls: Last ned XLS-fil
        filenames:
          contractual_availability: kontraktsmessig_tilgjengelighet
          energy_performance: ytelse
          energy_production: produksjon
          mppt_heatmap: mppt_heatmap
          mppt_production: mppt_produksjon
          power_curve: effektkurve
          production_chart: produksjon
        print_chart: Skriv ut diagram/graf
        tooltip: Télécharger les données
        view_data_table: Vis datatabell
        view_full_screen: Vis i fullskjerm
      external_theoretical: Værmodell
      fall_loss: Falltap
      fall_loss_intake: Falltap inntak
      fall_loss_penstock: Falltap rørgate
      filter: Filtrer
      frequency: Frekvens
      full_load_hours: Fullasttimer
      gen_l1l2: Gen L1-L2
      gen_l2l3: Gen L2-L3
      gen_l3l1: Gen L3-L1
      group_by_category: Gruppere etter kategori
      hours: Timer
      hours_without_alarms: Timer uten alarm
      inverter: Likerettere
      inverter_production_stats: "{amount} MW per {timeframe}"
      inverter_single: 'Likeretter: {name}'
      key_performance: Nøkkelprestasjon
      key_performance_for: Key Performance for {name}
      last_outage: Siste utfall var på {date}
      last_week: siste 7 dager
      level_downstream: Nivå nedstrøms
      level_upstream: Nivå oppstrøms
      measured: Målt
      most_frequent_alarms: Mest vanlige alarmer
      most_frequent_alarms_subtitle: Totalt {number} akkumulerte timer med alarmer i perioden {time_period}
      mppt: MPPT
      mppt_single: 'MPPT: {name}'
      no_new_outages: Ingen nye utfall
      no_weather_data: Ingen værdata
      normalized_power: Normalisert kraft [%]
      normalized_values: Normaliserte verdier
      operation: Drift
      operational_status: Driftsstatus
      operational_status_of_inverter: Driftsstatus for {name}
      operational_status_of_mppt: Driftsstatus for {name}
      operational_status_of_mppts: MPPT tidslinjer
      operational_status_per_turbine: Driftsstatus per turbin
      p50_target: P50
      penstock_pressure: Trommetrykk
      performance: Ytelse
      performance_ratio: Ytelsesforhold
      performance_subtitle: "{amount}% av ytelsesforhold i {timeframe}"
      potential: Potensial
      potential_loss: Potensielt tap
      power: Kraft
      power_current_or_voltage: Strøm, kraft eller spenning
      power_curve: Effektkurve
      power_curve_for: Effektkurve for {name}
      power_curve_inv_x_title: Teoretisk effekt
      power_curve_mppt_x_title: Referanseeffekt
      power_curve_subtitle: 'Energitap: {losses} MWh'
      power_curve_unit_solar: kW
      power_curve_unit_wind: MW
      power_curve_x_title: Teoretisk effekt
      power_curve_y_title: Målt effekt
      power_loss: Effekt tap
      power_y_title: Effekt [{unit}]
      production: Produksjon
      production_for_inverter: Produksjon for {name}
      production_in_mw: Produksjon i MW
      production_per_mppt: Produksjon per MPPT for {name}
      production_status_per_inverter: Produksjonsstatus per likeretter
      reactive_power: Reaktiv effekt
      regulation: Regulering
      remove_comparison: Fjern sammenligning
      set_point: Settpunkt
      set_point_autostart: Settpunkt oppstart
      set_point_water_level: Settpunkt vannstand
      shadow_testing_banner: Skyggetesting er aktivt for dette kraftverket — produksjonsplaner beregnes, men sendes ikke til Kaia Trade.
      show_abnormal: Vis kun de unormale
      show_all: Vis alle
      show_only_time_with_active_alarms: Kun vis tid med aktive alarmer
      specific_mppts: Spesifikke MPPT(er)
      start_date: Startdato
      start_time: Starttid
      start_time_must_be_before_end_time: Starttid må være før slutt-tid
      start_up_mode: Oppstart
      supervision_power: Tilsynelatende effekt
      temp_outside: Utetemperatur
      theoretical: Teoretisk
      time_ago: "{duration} siden"
      time_based: Tidsbasert beregning for tilgjengelighet.
      time_based_availability: Tidsbasert tilgjengelighet
      time_scope:
        3m: 3 måneder
        month: Måned
        quarter: Kvartal
        week: Uke
        year: År
      time_with_active_alarms: Tid med aktive alarmer
      tooltip_hidden: Hjelpetekst er deaktivert grunnet stort datasett
      total_availability: Total energibasert tilgjengelighet
      triggered_at: Utløst
      turbine: Turbin
      turbine_alarm_loss: "{mw_loss} MWh"
      turbine_power_curve_x_title: Vindhastighet
      turbine_power_curve_x_unit: m/s
      turbine_power_curve_y_title: Effekt
      turbine_power_curve_y_unit: MW
      turbine_single: 'Turbin: {name}'
      turbine_timeline: Tidslinje for turbin
      types_of_alarms: Alarmtyper
      unavailable: Utilgjengelig
      voltage: Spenning
      water_flow: Vannføring
      water_level: Vannstand
      water_level_downstream: Nedstrøms vannstand
      weather: Vær
      weather_data: Værdata
      weather_forecast: Værprognose
      weather_model: Værmodell
      wind_production_for: Produksjon i MW for turbiner
      wind_rose: Vindrose
      wind_rose_missing: Vindretning data er kun tilgjengelig for forrige uke. Kontakt Kaia support for mer informasjon.
      wind_rose_text: Hastigheter og retninger for valgt tidsperiode
    duration:
      plural:
        day: "{value} dager"
        hour: "{value} timer"
        minute: "{value} minutter"
      short:
        day: "{value}d"
        hour: "{value}h"
        minute: "{value}m"
      singular:
        day: "{value} dag"
        hour: "{value} time"
        minute: "{value} minutt"
    env_flow: Minstevannføring
    filter: Filtrer listen
    help:
      alarm_inactive: Alarm aktiv i løpet av de siste {age}, men nå inaktiv
      alarm_triggered: Alarm utløst for de siste {age}
      env_flow_threshold: Grense for minstevannføring mangler (kraftverksskjema)
      no_alarm: Ingen alarmer for de siste {age}
      no_live_data: Ingen sanntidsdata for de siste {age}
      sensor_type: Sensortype "{sensor_type}" mangler
      upper_alert_limit: Sensor upper_alert_limit mangler
    hydro:
      reservoir_status:
        avg_inflow: Gjennomsnittlig tilsig (24t)
        avg_inflow_tooltip: Forventet vanntilsig i gjennomsnitt over de neste 24 timene
        below_operational_min: Under driftsminimum
        days: "{days} dager"
        days_and_hours: "{days} dager, {hours} timer"
        days_and_hours_label: "{days} dager, {hours} timer"
        days_label: dager
        hours: "{hours} timer"
        hours_label: timer
        no_data: Ingen magasinstatusdata tilgjengelig
        no_inflow: Ingen tilsig
        of: av
        operational_energy: Driftsenergi
        operational_energy_tooltip: 'Tilgjengelig energi innenfor driftsgrensene, basert på vannstand.<br>Driftsområde: {operational_capacity} MWh, mellom {op_min_energy} MWh (driftsminimum) og {op_max_energy} MWh (driftsmaksimum).<br>Total magasinenergi: {absolute_volume} MWh av {full_capacity} MWh teoretisk. Utenfor driftsområde: {spare_capacity} MWh.'
        production_time: Full produksjonstid
        production_time_tooltip: Hvor lenge anlegget kan kjøre på full kapasitet ({power} MW) med nåværende magasinvolum og uten nytt tilsig
        reservoir_full: Magasinet er fullt
        time_to_fill: Tid til fullt magasin
        time_to_fill_tooltip: Tid for å fylle magasin basert på modellens driftsområde og gjennomsnittlig tilsig (24t) uten produksjon. Kan ikke nå full teoretisk kapasitet hvis drift innenfor begrenset område.
        title: Gjeldende magasinstatus
    nest_comm_down: Nest-kommunikasjon nede
    operations: Drift
    overflow: Overløp
    overview:
      asset: Eiendel
      capacity: Kapasitet
      components: Komponenter
      forecast: Prognose
      forecast_48h: Prognose om 48t
      forecast_now: Vær nå
      in_48h: Om 48t
      last_update: Sist oppdatert
      load: Last
      loss: Tap
      losses: Tap
      lost_revenue: Tap {currency_code}/h
      name: Navn
      only_revenue: Inntekt
      production: Produksjon
      production_stop: Produksjonsstopp
      revenue: Inntekt {currency_code}/t
      status: Status
      title: O&M Oversikt
    power_plant: Kraftverk
    power_plant_short: Verk
    power_plant_type:
      magazine: Magasinkraftverk
      run_of_river: Elvekraftverk
      solar: Solpark
      wind: Vindpark
    prod_status:
      outage: Driftsstans
      producing: Produserer
      ready: Startklar
    sensor_mapping:
      clear_search: Tøm søk
      discard_confirm: Du har ulagrede endringer. Forkaste dem?
      filter_all: Alle
      filter_mapped: Tilordnet
      filter_unmapped: Ikke tilordnet
      launcher: Sensoroppsett
      load_error: Kunne ikke laste sensorer.
      loading: Laster Nest-sensorer…
      mapped_heading: Tilordnet ({count})
      no_available_types: Ingen tilgjengelige sensortyper
      no_matches: Ingen sensorer samsvarer med søket.
      save_all: Lagre alle
      search: Søk etter navn
      unmapped: Ikke tilordnet
      unmapped_heading: Ikke tilordnet ({count})
      unsaved_changes: Ulagrede endringer
    sensor_types:
      chart: Graf
      sidebar: Sidemeny
    show_instant_triggers: Vis øyeblikkelige triggere
    status:
      hydro:
        low_natural_resource: Low natural resource
        missing_natural_resource: Mangler naturressurs
        missing_resource: Mangler naturressurs
        missing_status: Manglende status
        no_change: Ingen endring
        no_data: Ingen data
        no_energy: Ingen energi
        normal: Normal
        normal_operation: Normal drift
        one_year_ago: ett år siden
        outage: Utfall
        recent_issue_solved: Nylig løst problem
        underperforming: Underpresterer
      neutral:
        low_natural_resource: Low natural resource
        missing_natural_resource: Utenfor driftsområde
        missing_resource: Utenfor driftsområde
        missing_status: Manglende status
        no_change: Ingen endring
        no_data: Ingen data
        no_energy: Ingen energi
        normal: Normal
        normal_operation: Normal drift
        one_year_ago: ett år siden
        outage: Utfall
        recent_issue_solved: Nylig løst problem
        underperforming: Underpresterer
      solar:
        low_natural_resource: Lite naturressurs
        missing_natural_resource: Mangler naturressurs
        missing_resource: Mangler naturressurs
        missing_status: Manglende status
        no_change: Ingen endring
        no_data: Ingen data
        no_energy: Ingen energi
        normal: Normal
        normal_operation: Normal drift
        one_year_ago: ett år siden
        outage: Utfall
        recent_issue_solved: Nylig løst problem
        resource_above_threshold: Ressurs over terskel
        resource_below_threshold: Ressurs under terskel
        underperforming: Underpresterer
      wind:
        low_natural_resource: Lite naturressurs
        missing_natural_resource: Utenfor driftsområde
        missing_resource: Mangler naturressurs
        missing_status: Manglende status
        no_change: Ingen endring
        no_data: Ingen data
        no_energy: Ingen energi
        normal: Normal
        normal_operation: Normal drift
        one_year_ago: ett år siden
        outage: Utfall
        recent_issue_solved: Nylig løst problem
        underperforming: Underpresterer
    technical: Teknisk
